import Box from '@mui/material/Box'
import FilterBoxy from '../../svg/boxyIcons/FilterBoxy'
import FilterModern from '../../svg/modernIcons/FilterModern'
import FilterDefault from '../../svg/defaultIcons/FilterDefault'

const FilterIcon = () => {
    const iconSelect = localStorage.getItem('iconsSelect')
    const icon = iconSelect === 'Boxy'
        ? <FilterBoxy />
        : iconSelect === 'Modern'
            ? <FilterModern />
            : <FilterDefault />

    return <Box sx={{ display: 'flex', height: 25, width: 25 }}>{icon}</Box>
}

export default FilterIcon
